import { LOADING, LOADED } from '../actionTypes/BazaarVoiceActionTypes';

export const libraryLoading = () => ({
    type: LOADING,
});

export const libraryLoaded = () => ({
    type: LOADED,
});
